import React from 'react';
import { useT } from '../i18n/LanguageContext';
import { DistributorActivity } from '../components/distributor/DistributorActivity';

export default function DistributorClinicShipments() {
  const t = useT();
  return (
    <div className="p-6 space-y-4">
      <h1 className="text-2xl font-semibold text-slate-900">{t('Shipments')}</h1>
      <DistributorActivity t={t} onlyShipments />
    </div>
  );
}
